// extracted by mini-css-extract-plugin
export var stepActive = "_2z-3";
export var stepCompleted = "_2z-4";
export var stepConnectorLine = "_2z-b";
export var stepIndicatorCircle = "_2z-6";
export var stepIndicatorCircleCompleted = "_2z-7";
export var stepIndicatorCircleDefault = "_2z-8";
export var stepIndicatorTextCompleted = "_2z-9";
export var stepIndicatorTextDefault = "_2z-a";
export var stepPending = "_2z-5";
export var wizardContainer = "_2z-1";
export var wizardContent = "_2z-2";
export var wizardModal = "_2z-0";